import { Component, inject } from '@angular/core';
import { ImageCompressService } from '../../../image-compress/image-compress.service';
import { ImagePreviewV2InitService } from '../../../image-preview-v2/service/init/image-preview-v2-init.service';
import { RolloutProgressReportAnswersService } from '../../service/answers/rollout-progress-report-answers.service';
import { RolloutProgressReportCombinedService } from '../../service/combined/rollout-progress-report-combined.service';
import { RolloutProgressReportFilesService } from '../../service/files/rollout-progress-report-files.service';

@Component({
  selector: 'app-report-view-base',
  imports: [],
  template: '',
})
export class ReportViewBaseComponent {
  private readonly answerService = inject(RolloutProgressReportAnswersService);
  private readonly imagePreviewV2InitService = inject(
    ImagePreviewV2InitService,
  );
  private readonly fileService = inject(RolloutProgressReportFilesService);
  private readonly imageCompressService = inject(ImageCompressService);
  readonly combinedService = inject(RolloutProgressReportCombinedService);

  showImagePreview$ = this.imagePreviewV2InitService.getShowImagePreview$();
  imagePreviewAttachments$ =
    this.imagePreviewV2InitService.getImagePreviewAttachments$();
  isLoadingImagePreview$ = this.imagePreviewV2InitService.getisLoadingV2$();

  downloadImages = (files: { fileName: string; fileId: string }[]) => {
    this.fileService.downloadFiles(files);
  };

  uploadImage = ($event: Event) => {
    const { reportId, definitionId, group, isFileAndText } =
      this.imagePreviewV2InitService.getImagePreviewData();

    this.imageCompressService.compressFilesAndMutate($event, true, (formData) =>
      this.answerService.createFile$(
        reportId,
        definitionId,
        formData,
        group,
        isFileAndText,
        true,
      ),
    );
  };

  deleteImage = (fileId: string) => {
    const { reportId, definitionId, group } =
      this.imagePreviewV2InitService.getImagePreviewData();

    this.answerService
      .deleteFile$(reportId, definitionId, fileId, group)
      .mutate();
  };

  closeImagePreview() {
    this.imagePreviewV2InitService.clearImagePreviewAttachments();
    this.imagePreviewV2InitService.setShowImagePreview(false);
  }
}
